import { queueMessage } from '../../lib/outbox';
import { t } from '../../i18n';
import { replyLabel, type ChatMessage } from './messageUtils';

// Aashirwad (docs/indian-touches.md, D280): a one-tap blessing, sent as an
// ordinary sealed reply. Everything here happens on the device.

/** Someone else's message a blessing can answer: not mine, a system line, gone or unreadable. */
export function canBless(message: ChatMessage, isOwn: boolean): boolean {
  return (
    !isOwn &&
    !message.deletedAt &&
    !message.e2ee?.locked &&
    message.type !== 'system' &&
    Boolean(message.sender) &&
    !message.sender?.deleted
  );
}

/** The words to send: your own, or "Jeete raho 🙏" in the app's language. */
export function blessingText(words: string): string {
  return words.trim() || t('chat.bless.default');
}

/** Sends the blessing as a reply to `message`, through the outbox like any text (M23). */
export function sendBlessing(message: ChatMessage, words: string): string {
  return queueMessage({
    conversationId: message.conversationId,
    content: blessingText(words),
    replyToId: message.id,
    replyTo: {
      id: message.id,
      senderId: message.sender?.id ?? null,
      senderName: message.sender?.displayName ?? t('chat.unknown'),
      type: message.type,
      preview: replyLabel(message),
      deleted: false,
      createdAt: message.createdAt,
    },
  });
}
